///* ----------------------------------------------------------------------------------
//import読み込み
//---------------------------------------------------------------------------------- */
import {
  styleResetFunc,
} from './common/_common';
import {
  hoverFunc,
  telLinkFunc,
  uaHoverFunc,
  hoverOtherFunc
} from './common/_hoverFunc';
import {
  heightLine,
  heightLineSetFunc,
  heightLineFunc
} from './common/_heightLine';
import {
  pageLinkAnimationFunc,
  pageMoveAnkerFunc
} from './common/_pageLinkAnimation';
import {
  buttonActionFunc
} from './common/_buttonAction';
import {
  areaChangeFunc
} from './common/_areaChange';
import {
  mapSvgFunc
} from './lib/_map';

//* -------------------------------------------------------------------
//通常実行
//------------------------------------------------------------------- */
let indexTopLen, setTimer, setResponsibleCheck;
//* ----------------------------------------------------------------------------------
//window実行
//---------------------------------------------------------------------------------- */
////// ロード時
let indexTop = $('#indexTop').length;
if (indexTop == 1) {
	//SVGMAP
  mapSvgFunc();
}
$(window).on('load', function () {
  pageLinkAnimationFunc();
  pageMoveAnkerFunc();

  //高さ調整
  heightLine();
  heightLineSetFunc();
  //mainタグ高さ調整
  styleResetFunc();

  //共通系
  buttonActionFunc();
	//エリア切り替え
	areaChangeFunc();
});

// リサイズ時
/*リサイズ後,200msで発火する設定*/
$(window).on('resize', function () {
  if (setTimer !== false) {
    clearTimeout(setTimer);
  }
  setTimer = setTimeout(function () {
    //リサイズ終了後の処理
    heightLineSetFunc();
    styleResetFunc();
  }, 200);
});

// スクロール時
$(window).on('scroll', function () {
});
///* ----------------------------------------------------------------------------------
//ユーザーエージェント判別実行(uaFlag：1→スマホ&タブレット・2→IE・3→その他PC)
//---------------------------------------------------------------------------------- */
var uaFlag = 0;
if ((
    navigator.userAgent.indexOf('iPhone') > 0) ||
  (navigator.userAgent.indexOf('iPod') > 0) ||
  (navigator.userAgent.indexOf('iPad') > 0) ||
  (navigator.userAgent.indexOf('Android') > 0) ||
  (navigator.userAgent.indexOf('BlackBerry') > 0) ||
  (navigator.userAgent.indexOf('PlayBook') > 0) ||
  (navigator.userAgent.indexOf('Kindle') > 0) ||
  (navigator.userAgent.indexOf('Silk') > 0) ||
  (navigator.userAgent.indexOf('Windows Phone') > 0) ||
  (navigator.userAgent.indexOf('Nokia') > 0)
) {
  // スマホ・タブレット時の処理
  uaFlag = 1;
  uaHoverFunc();
} else {
  // PC時の処理
  uaFlag = 3;
  hoverFunc();
  telLinkFunc();
  hoverOtherFunc();
}
/* ----------------------------------------------------------------------------------
IEだけの時
---------------------------------------------------------------------------------- */
var userAgent = window.navigator.userAgent.toLowerCase();
if (userAgent.match(/(msie|MSIE)/) || userAgent.match(/(T|t)rident/)) {

}